/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./InspectorProfile.module.css";

function Services() {
    const services = [
        {
            icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/67ff7051858fd1f3506a9c34a3b6a59362f4067675bb9d5ff57cb39d1a9fcd8a?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625",
            name: "Foundation Inspection",
        },
        {
            icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/b952855d7fcbc25a0bfe5bbf173c5cb597fca70dda55f0952c4c334107393711?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625",
            name: "Roof Inspection",
        },
        {
            icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/385feab38fe6d085703e6755327bc68b07666c0be6cfdea1c4a52828c6867164?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625",
            name: "HVAC System Check",
        },
    ];

    return (
        <section className={styles.servicesSection}>
            <h3 className={styles.servicesTitle}>Detailed Services:</h3>
            <p className={styles.servicesDescription}>
                Breakdown of what is included in the inspection process (e.g., foundation, roof, HVAC, plumbing).
            </p>
            <div className={styles.servicesList}>
                {services.map((service, index) => (
                    <div key={index} className={styles.serviceItem}>
                        <img src={service.icon} alt="" className={styles.serviceIcon} />
                        <span className={styles.serviceName}>{service.name}</span>
                    </div>
                ))}
            </div>
            <div className={styles.sampleReportSection}>
                <div>
                    <h4 className={styles.sampleReportTitle}>Sample Report:</h4>
                    <p className={styles.sampleReportDescription}>Preview a sample inspection report to see what's included.</p>
                </div>
                <button className={`${styles.sampleReportButton} tw-bg-primary hover:tw-bg-primary_hover`}>View Sample Report</button>
            </div>
        </section>
    );
}

export default Services;
